import PropTypes from 'prop-types';
import { Stack, InputAdornment, TextField, Button } from '@mui/material';
// components
import { Iconify } from '../../../../components';

// ----------------------------------------------------------------------

export default function UserTableListToolbar({ filterName, onFilterName, onResetFilter }) {
    return (
        <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} sx={{ py: 2, px: 2.5 }}>

            <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={filterName}
                onChange={(event) => onFilterName(event.target.value)}
                placeholder="Search users..."
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Iconify icon={'eva:search-fill'} sx={{ color: 'text.disabled', width: 20, height: 20 }} />
                        </InputAdornment>
                    ),
                }}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        '& fieldset': { borderColor: 'rgba(145, 158, 171, 0.2)' },
                        '&:hover fieldset': { borderColor: 'rgba(145, 158, 171, 0.4)' },
                    },
                }}
            />
            {filterName && (
                <Button
                    color="inherit"
                    sx={{ flexShrink: 0, color: 'text.secondary', textTransform: 'none' }}
                    onClick={onResetFilter}
                    startIcon={<Iconify icon="eva:close-fill" />}
                >
                    Clear
                </Button>
            )}
        </Stack>
    );
}

UserTableListToolbar.propTypes = {
    filterName: PropTypes.string,
    onFilterName: PropTypes.func,
    onResetFilter: PropTypes.func,
};